import {useEffect, useRef} from "react";

/**
 * Runs a callback function only once when the component mounts, similar to `useEffect`.
 */
function useEffectOnce(callback: VoidFunction, deps: any[], cleanup?: VoidFunction) {
  const shouldRun = useRef(true);

  useEffect(() => {
    if (shouldRun.current) {
      shouldRun.current = false;

      callback();
    }

    return () => {
      if (cleanup) {
        cleanup();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useEffectOnce;
